import { ArrowRight, Flame, Volume1, Leaf, Snowflake, Hammer, ShieldCheck } from "lucide-react";
import { Countdown } from "./Countdown";
import { PriceBlock } from "./PriceBlock";
import { useProduct, IMAGES, promoEndLabel } from "@/lib/product";

const TRUST = [
  [Volume1, "39 dB(A)", "mode silencieux"],
  [Leaf, "Classe A++", "SEER 6,1"],
  [Snowflake, "12 000 BTU", "3,5 kW réversible"],
  [Hammer, "0 perçage", "kit fenêtre inclus"],
];

export const Hero = () => {
  const { product } = useProduct();
  return (
    <section data-testid="hero-section" className="relative overflow-hidden hero-bg">
      <div className="container-x grid lg:grid-cols-[1.05fr_1fr] gap-12 lg:gap-16 pt-10 sm:pt-16 pb-16 sm:pb-24 items-center">
        <div className="flex flex-col gap-7">
          <div className="flex flex-wrap gap-2 fade-up">
            {product?.promo_active && (
              <span data-testid="hero-destockage-badge" className="badge-heat">
                <Flame className="w-3.5 h-3.5" /> Offre de déstockage
              </span>
            )}
            <span className="eyebrow">Midea PortaSplit · 4-en-1 réversible</span>
          </div>
          <h1 data-testid="hero-headline" className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.04] text-slate-900 fade-up d1">
            La fraîcheur d'un split.{" "}
            <span className="text-ice">La liberté d'un mobile.</span> Sans percer un seul mur.
          </h1>
          <p className="text-base sm:text-lg text-slate-600 leading-relaxed max-w-xl fade-up d2">
            Le climatiseur Midea PortaSplit 12 000 BTU refroidit, chauffe, déshumidifie et ventile jusqu'à ~40 m². Son compresseur reste dehors : à l'intérieur, à peine 39 dB(A). Installé en 10 minutes par la fenêtre, sans technicien.
          </p>
          <div className="price-card fade-up d3">
            <PriceBlock prefix="hero" note />
            {product?.promo_active && (
              <div data-testid="hero-countdown-container" className="flex flex-col gap-2 pt-5 mt-5 border-t border-slate-200/80">
                <span className="text-xs font-bold uppercase tracking-[0.18em] text-orange-600">L'offre se termine le {promoEndLabel(product.promo_end)}</span>
                <Countdown prefix="hero" />
              </div>
            )}
          </div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 fade-up d4">
            <a href="#commander" data-testid="hero-cta-button" className="btn-heat text-base">
              Commander maintenant <ArrowRight className="w-5 h-5" />
            </a>
            <span className="flex items-center gap-2 text-sm text-slate-500">
              <ShieldCheck className="w-4 h-4 text-sky-600" /> Rétractation 14 jours · Garantie légale 2 ans
            </span>
          </div>
        </div>
        <div className="relative fade-up d2" data-testid="hero-product-image-container">
          <div className="hero-img-wrap bg-white flex items-center justify-center p-6 sm:p-10">
            <img src={IMAGES.packSide} alt="Midea PortaSplit 12 000 BTU : unité intérieure sur roulettes et unité extérieure" className="w-full h-full object-contain" fetchpriority="high" />
          </div>
          <div className="floating-chip left-4 -bottom-6 sm:-left-6">
            <span className="text-xs uppercase tracking-[0.16em] text-slate-500">Compresseur</span>
            <span className="font-display font-bold text-slate-900">à l'extérieur</span>
          </div>
          <div className="floating-chip right-4 -top-5 sm:-right-4 hidden sm:flex">
            <span className="text-xs uppercase tracking-[0.16em] text-slate-500">Surface</span>
            <span className="font-display font-bold text-slate-900">jusqu'à ~40 m²</span>
          </div>
        </div>
      </div>
      <div className="container-x pb-14">
        <div data-testid="hero-trust-strip" className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {TRUST.map(([Icon, title, sub]) => (
            <div key={title} className="trust-item">
              <Icon className="w-5 h-5 text-sky-600 shrink-0" />
              <div className="flex flex-col">
                <span className="font-display font-bold text-slate-900 leading-tight">{title}</span>
                <span className="text-xs text-slate-500">{sub}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
